import { SidebarButton } from "@shared/Sidebar";
import { getLauncherUrl } from "../../config/external-apps";
import { isSSOSession } from "@shared/GoogleLoginButton/user-slice/auto-login";

export const BackToLauncher = () => {
  if (!isSSOSession()) return null;

  const handleClick = () => {
    window.location.href = getLauncherUrl();
  };

  return (
    <SidebarButton
      hoverText="Launcher"
      onClick={handleClick}
      data-testid="back-to-launcher"
    >
      <span style={{ fontSize: "18px" }}>⬅</span>
    </SidebarButton>
  );
};
